/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import macImage from '../../../../../assets/images/mac_trade.png';
import success from '../../../../../assets/svg-icons/success.svg';
import StarFilled from '../../../../../assets/svg-icons/StarFilled.svg';
import StarOutlined from '../../../../../assets/svg-icons/StarOutlined.svg';
import SmileOutlined from '../../../../../assets/svg-icons/SmileOutlined.svg';
import './style.scss';
import { SuccessProps } from 'presentation/entities/success.entity';
import { trackingEvent } from 'data/usecases/tracking-event';

export const DayTradeSuceesActiveAcccount = ({ course }: SuccessProps): JSX.Element => {
    const [note, selectNote] = useState(0);
    const notes = [1, 2, 3, 4, 5];
    const [sendNote, setSendNote] = useState(false);

    useEffect(() => {
        const savedNote = localStorage.getItem('tradeNoteCourse');

        if (savedNote !== null) {
            setSendNote(true);
        }
    }, []);
    return (
        <div className="col-sm-12 active_account_body">
            <div className="container">
                <div className="congradulations_active_account">
                    <img src={success} alt="" />
                    <p>PARABÉNS!</p>
                </div>
                <div className="title_active_account">
                    <h1>Você concluiu o curso Day Trade para Iniciantes</h1>
                </div>
                <div className="text_and_image">
                    <div>
                        <div className="title_active_account">
                            <p>
                                Aproveite para assinar a Plataforma Profit Toro Trader e aplicar seus conhecimentos na
                                live com nossos especialistas.
                            </p>
                        </div>

                        <div className=" text_content_active_account">
                            {!sendNote && (
                                <div className="star_active_account">
                                    <p>Avalie o curso</p>

                                    {notes.map((n, i) => (
                                        <img
                                            src={note >= n ? StarFilled : StarOutlined}
                                            onMouseEnter={() => selectNote(n)}
                                            onMouseLeave={() => selectNote(0)}
                                            onClick={() => {
                                                localStorage.setItem('tradeNoteCourse', `${n}`);
                                                setSendNote(true);
                                                trackingEvent.elementClicked({
                                                    productAreaOrigin: 'Aprenda',
                                                    element: 'Avalie o curso',
                                                    group: 'Tela de Conclusão do curso',
                                                    step: 'Não se aplica',
                                                    text: course?.name,
                                                    timeResponsavel: 'Sky',
                                                    specificProperties: {
                                                        Avaliações: `${n}`,
                                                    },
                                                });
                                            }}
                                            alt=""
                                            key={i}
                                        />
                                    ))}
                                </div>
                            )}
                            {sendNote && (
                                <div className="star_active_account">
                                    <p>Agradecemos sua avaliação!</p>

                                    <img src={SmileOutlined} alt="" />
                                </div>
                            )}
                            <div>
                                <a
                                    href={'https://app.toroinvestimentos.com.br/minha-conta/plataformas'}
                                    className="btn-next mb-2"
                                    onClick={() => {
                                        trackingEvent.elementClicked({
                                            productAreaOrigin: 'Aprenda',
                                            element: 'Assinar Profit Toro Trader gratuito',
                                            group: 'Tela de Conclusão do curso',
                                            step: 'Não se aplica',
                                            text: course?.name,
                                            timeResponsavel: 'Sky',
                                        });
                                    }}
                                >
                                    Assinar Profit Toro Trader gratuito
                                </a>
                                <a
                                    href={
                                        'https://app.toroinvestimentos.com.br/aprenda/operando-day-trade-com-mais-seguranca/1/1'
                                    }
                                    className="white_button_active_account"
                                    onClick={() => {
                                        trackingEvent.elementClicked({
                                            productAreaOrigin: 'Aprenda',
                                            element: 'Aprenda a operar com segurança',
                                            group: 'Tela de Conclusão do curso',
                                            step: 'Não se aplica',
                                            text: course?.name,
                                            timeResponsavel: 'Sky',
                                        });
                                    }}
                                >
                                    Aprenda a operar com segurança
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="mac_image">
                        <img src={macImage} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};
